import homeIndexAdsBackUp from '@/assets/info/home-index-ads.png'
// import homeIndexAds from '@/assets/info/home-index-ads2.png'
import homeIndexAds from '@/config/assets/nuanwa/home/home-index-ads2.gif'


export const HOME_INDEX_IMG_URL1 = homeIndexAds
// export const HOME_INDEX_URL1 = 'https://m.aibangbaoxian.net/mf/dadi/home?version=shengji&channelCode=NXHM&channelSource=jkym-fc'
// export const HOME_INDEX_URL1 = 'https://act.aibangbaoxian.net/juhe/002/receive?version=MS2&channelCode=QWAB&channelSource=jkym-fc-zengxian'
export const HOME_INDEX_URL1 = 'https://m.aibangbaoxian.net/wxAppBusiness?shuntCode=AB2026060904'


